import { Styles, StyleSheet } from '@react-pdf/renderer';

import { theme } from '~/styles/theme';

import { convertChakraToPdfStyles } from './chakra-to-pdf';

export function createPdfStyles<T extends Styles>(rawStyles: T) {
  const styles = StyleSheet.create(rawStyles);
  return convertChakraToPdfStyles(theme, styles);
}
